import EmptySection from '@/components/EmptySection';
import StudentViewSection from '@/components/StudentViewSection';
import Constants from '@/Constants';
import { useContentLanguageChange } from '@/hooks/useContentLanguageChange';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import { ApplicationState } from '@/store';
import { contentsClear, contentsCompletedClear } from '@/store/item/action';
import { coursesClear, coursesCompletedClear } from '@/store/list/action';
import { programsClear, programsCompletedClear } from '@/store/program/action';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';

const CompletedPage: React.FC = () => {
    const COMPLETED_VIEW_TYPE = 'listCompletedStudentView';
    const dispatch = useDispatch();

    const { strings, loadingMyCourses, loadingMyContents, totalMyCourses, totalMyContents } = useSelector((state: ApplicationState) => {
        return {
            strings: state.locale.data,
            loadingMyCourses: state.lists.listData[COMPLETED_VIEW_TYPE].loading,
            loadingMyContents: state.itens.listData[COMPLETED_VIEW_TYPE].loading,
            totalMyCourses: state.lists.listData[COMPLETED_VIEW_TYPE].total,
            totalMyContents: state.itens.listData[COMPLETED_VIEW_TYPE].total,
        };
    });

    const [refreshStudentViewSection, setRefreshStudentViewSection] = useState<boolean>(true);

    useContentLanguageChange({
        onChange: () => {
            setTimeout(() => {
                setRefreshStudentViewSection(true);
            }, 100);
        },
        unmountChange: () => {
            setRefreshStudentViewSection(false);
            dispatch(coursesClear());
            dispatch(contentsClear());
            dispatch(programsClear());
        },
    });

    useEffect(() => {
        analyticsService.logEvent(FlowEvents.MY_COMPLETED);
        dispatch(coursesCompletedClear());
        dispatch(contentsCompletedClear());
        dispatch(programsCompletedClear());
    }, [dispatch]);

    return (
        <div className="mine-completed">
            {refreshStudentViewSection && <StudentViewSection hideTitle={true} viewType={COMPLETED_VIEW_TYPE} />}

            {!(totalMyCourses && totalMyCourses > 0) && !(totalMyContents && totalMyContents > 0) && !loadingMyCourses && !loadingMyContents && (
                <div className="empty-section-container">
                    <EmptySection iconName={Constants.icons.SMS_FAILED} message={strings.EMPTY_SECTION_MESSAGE} />
                </div>
            )}
        </div>
    );
};
export default CompletedPage;
